import {Component, EventEmitter, Inject, Input, OnInit, Output} from '@angular/core';
import {ModalRef} from "../../../tandem-core/models/modal-ref";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {FormOption} from "../../../tandem-core/components/forms/form-option";
import {Asset} from "../../models/asset";
import {user} from "@angular/fire/auth";
import {AssetDetails} from "../../models/financial-position-template";

@Component({
  selector: 'tandem-asset-dialog',
  templateUrl: './asset-dialog.component.html',
  styleUrls: ['./asset-dialog.component.scss']
})
export class AssetDialogComponent implements OnInit {

  @Input() inputAsset: Asset | undefined;
  title: string = 'Modify Asset';
  mode: 'create' | 'edit' | 'view' | 'proposeChanges' = 'create';

  assetForm: FormGroup = new FormGroup<any>({});

  public modalRef?: ModalRef;

  LIQUIDITY_OPTIONS: FormOption[] = [
    {
      label: 'Instant',
      value: 'Instant'
    },
    {
      label: 'Days',
      value: 'Days'
    },
    {
      label: 'Weeks',
      value: 'Weeks'
    },
    {
      label: 'Months',
      value: 'Months'
    },
    {
      label: 'Years',
      value: 'Years'
    },
  ];

  assetDetails?: AssetDetails;


  @Output() formSubmit = new EventEmitter<any>();


  defaultName = `Don't overlook the name! It's very important to provide as much detail as possible so your coach has insight. For example, "Checking Account" is not nearly as insightful as "Chase Bank Total Checking Account"`;
  defaultValue = `The amount of cash you could net in your pocket if you were to sell or liquidate the asset`;
  defaultAPR = `The percentage return your asset generates for you on an annual basis`;
  defaultExpenses = `Any expenses associated with maintaining the asset. For example, a car has associated expenses of insurance, maintenance, repairs, gas, and depreciation`;
  defaultLiquidity = `How much time it would take you to sell or liquidate your asset and get the full market value in cash`;


  constructor(private fb: FormBuilder) {
    // this.inputAsset = this.modalRef.data?.inputAsset;
    // this.title = this.modalRef.data?.title;
    // this.mode = this.modalRef.data?.mode;
  }

  ngOnInit(): void {
    this.assetForm = this.fb.group({
      name: [this.inputAsset?.name, Validators.required],
      value: [this.inputAsset?.value, [Validators.required, Validators.min(0), Validators.max(999999999999)]],
      annualPercentageReturn: [parseFloat(((this.inputAsset?.annualPercentageReturn || 0) * 100).toFixed(4)), [Validators.required, Validators.max(500)]],
      liquidityQuantity: [this.inputAsset?.liquidityQuantity, Validators.min(0)],
      liquidityUnits: [this.inputAsset?.liquidityUnits, Validators.required],
      associatedExpenses: [this.inputAsset?.associatedExpenses],
    });
    if (this.mode === 'view' || (this.mode === 'proposeChanges' && this.inputAsset)) {
      this.disableAllControls(this.assetForm);
    }
    if (this.mode === 'proposeChanges' && !this.inputAsset) {
      this.assetForm.get('value')?.setValue(0);
    }
    if (this.mode === 'proposeChanges') {
      this.assetForm.get('value')?.disable();
    }
    // If the annualPercentageReturn is 0, set it to null to avoid showing 0% in the form
    if (!this.inputAsset && this.assetForm.get('annualPercentageReturn')?.value == 0) {
      this.assetForm.get('annualPercentageReturn')?.setValue(null);
    }
    this.assetForm.get('liquidityUnits')?.valueChanges.subscribe(v => {
      if (v === 'Instant') {
        this.assetForm.get('liquidityQuantity')?.setValue(null);
      }
    })
    this.assetForm.get('annualPercentageReturn')?.valueChanges.subscribe(apr => {
      let userInput = apr;

      const segments: string[] =  userInput.toString().split('.');

      if(segments[1]?.length > 2) {
        userInput = `${segments[0]}.${segments[1].substring(0, 2)}`
        this.assetForm.get('annualPercentageReturn')?.setValue(userInput)
      }
    })
    // this.assetForm.get('value')?.valueChanges.subscribe(hehe => {
    //   let userInput = hehe;
    //   const segments: string[] =  userInput.toString().split('.');
    //   if (hehe?.toString().length > 12) {
    //     hehe = hehe?.toString().slice(0, 12);
    //     this.assetForm.get('value')?.setValue(parseInt(hehe, 10));
    //   }
    //   if (segments[1]?.length > 2) {
    //     userInput = `${segments[0]}.${segments[1].substring(0, 2)}`
    //     this.assetForm.get('value')?.setValue(userInput);
    //   }
    // })
  }
  public onSubmit() {
    console.log(this.assetForm)
    this.modalRef?.close({
      name: this.assetForm.get('name')?.value,
      value: Number(this.assetForm.get('value')?.value),
      annualPercentageReturn: Number(this.assetForm.get('annualPercentageReturn')?.value) / 100,
      liquidityQuantity: Number(this.assetForm.get('liquidityQuantity')?.value),
      liquidityUnits: this.assetForm.get('liquidityUnits')?.value,
      associatedExpenses: this.assetForm.get('associatedExpenses')?.value});
  }

  public onCancel() {
    this.modalRef?.close();
  }

  disableAllControls(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.controls[key];
      control.disable();
    });
  }

  onFormSubmit() {
    if (this.mode !== 'view' && !this.assetForm.invalid) {
      this.onSubmit();
    }
  }
}
